import {
  lgUp,
  mdUp,
  smUp,
  xlUp,
  xs,
  xxl
} from "./chunk.QLZDQDDJ.js";
import {
  o,
  r
} from "./chunk.4JTBA2KG.js";

// src/styles/component-mobile.styles.ts
function createVisibilityStyles(breakpoint) {
  const styles = ` [hidden-${breakpoint}] { display: none; } [visible-${breakpoint}] { display: block; } [visible-${breakpoint}-inline] { display: inline; } [visible-${breakpoint}-inline-block] { display: inline-block; } [visible-${breakpoint}-flex] { display: flex; } [visible-${breakpoint}-inline-flex] { display: inline-flex; } `;
  return o(styles);
}
var component_mobile_styles_default = r` ${xs(createVisibilityStyles("xs"))} ${smUp(createVisibilityStyles("sm"))} ${mdUp(createVisibilityStyles("md"))} ${lgUp(createVisibilityStyles("lg"))} ${xlUp(createVisibilityStyles("xl"))} ${xxl(createVisibilityStyles("xxl"))} `;

export {
  component_mobile_styles_default
};
